export default __webpack_public_path__ + "static/media/home_office.eefb439b.png";